var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "zj-pagination" },
    [
      _c(
        "el-pagination",
        {
          ref: "pagination",
          attrs: {
            background: "",
            "hide-on-single-page": _vm.hideSinglePage,
            layout:
              "" +
              (_vm.showTotal ? "total," : "") +
              (_vm.pageSizes.length > 1 ? "sizes," : "") +
              "prev, pager, next, jumper, slot",
            "page-sizes": _vm.pageSizes,
            total: _vm.page.total,
            "page-size": _vm.page.size ? _vm.page.size : 10,
            "current-page": _vm.page.current,
          },
          on: {
            "current-change": _vm.currentChange,
            "size-change": _vm.sizeChange,
          },
        },
        [_c("span", { staticClass: "jump-btn" }, [_vm._v("确定")])]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }